module.exports = __webpack_public_path__ + "img/bg_content_header_03.7a88113.png";